import errorHandlers from '@/services/error-handlers';
import events from '@/services/events';
import http from '@/services/http';



export default {
  namespaced: true,

  state: {
    methods: [],
    methodsAreLoading: false,
    selectedMethodId: null
  },

  getters: {
    selectedShippingMethod(state) {
      const method = state.methods.find(m => m.identifier === state.selectedMethodId);

      return method || {
        fee: 0
      };
    },

    shipping(state) {
      return state;
    }
  },

  actions: {
    autoSelectMethod({ commit, state }) {
      const defaultMethod = state.methods.find(method => method.isDefault) || state.methods[0];
      const selectedMethod = state.methods.find(method => method.identifier === state.selectedMethodId);

      if (!selectedMethod) {
        if (state.selectedMethodId) {
          events.emit('notification', {
            type: 'info',
            message: 'Shipping options have changed. Please review your selection.'
          });
        }

        commit('SET_SELECTED_METHOD_ID', defaultMethod ? defaultMethod.identifier : null);
      }
    },

    async getMethods({ commit, dispatch, rootGetters }) {
      try {
        const order = rootGetters['orders/order'];
        const orderDetails = rootGetters['session/orderDetails'];
        const selectedLocation = rootGetters['locations/selectedLocation'];
        const address = orderDetails.deliveryAddress;

        commit('SET_METHODS_LOADING_STATUS', true);

        const response = await http.post(`/cardfree-api/v1/shipping/${selectedLocation.storeId}/estimate`, {
          orderValue: order.subtotal,
          shipToAddress: {
            city: address.city,
            countryCode: address.countryCode,
            line1: address.line1,
            line2: address.line2,
            postalCode: address.postalCode,
            state: address.state
          }
        });

        commit('SET_METHODS', response.data);
      }

      catch (error) {
        errorHandlers.silent(error);
        commit('SET_METHODS', []);
      }

      finally {
        dispatch('autoSelectMethod');
        commit('SET_METHODS_LOADING_STATUS', false);
      }
    },

    selectMethod({ commit }, id) {
      commit('SET_SELECTED_METHOD_ID', id);
    }
  },

  mutations: {
    SET_METHODS(state, methods) {
      state.methods = methods || [];
    },

    SET_METHODS_LOADING_STATUS(state, areLoading) {
      state.methodsAreLoading = areLoading;
    },

    SET_SELECTED_METHOD_ID(state, id) {
      state.selectedMethodId = id;
    }
  }
};
